import React from "react";

import { ButtonStandard, ModalBase, Text } from "@performyard/py-components";

export interface RemoveEmployeeModalProps {
	isOpen: boolean;
	employeeName: string;
	isPending?: boolean;
	onConfirm: () => void;
	onClose: () => void;
}

const RemoveEmployeeModal: React.FC<RemoveEmployeeModalProps> = ({
	isOpen,
	employeeName,
	isPending,
	onConfirm,
	onClose,
}) => (
	<ModalBase isOpen={isOpen} onClose={onClose}>
		<div className="box-border w-[432px] px-6 pb-6">
			<Text size="sub-heading" weight="semi-bold" dangerouslySetClassName="text-center">
				Remove Employee?
			</Text>
			<Text size="paragraph-1" dangerouslySetClassName="mt-4 text-center">
				Are you sure you want to remove &quot;{employeeName}&quot; from this role?
			</Text>
			<div className="mt-6 flex justify-center gap-2">
				<div>
					<ButtonStandard
						size="large"
						variant="outline"
						color="neutral"
						onClick={onClose}
						disabled={isPending}
					>
						Cancel
					</ButtonStandard>
				</div>
				<div>
					<ButtonStandard size="large" color="primary" onClick={onConfirm} disabled={isPending}>
						Yes, Remove
					</ButtonStandard>
				</div>
			</div>
		</div>
	</ModalBase>
);

export default RemoveEmployeeModal;
